import React, { Fragment } from "react";
import { Button, TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Row, Col, Grid } from "@vds/grids";

export function Internet5GService(props) {
  return (
    <Grid
      className="OutofFranchise"
      style={{ marginLeft: "3px" }}
      colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
      colGutter={false}
    >
      {(props?.addressQualificationDetails?.Qualified === "true"||props?.addressQualificationDetails?.QualifiedCBand=== "true") ? (
       
        <Row className={`Page-Content ${props.bgForFirst} ${props.isMobileOnly?'mobile':''} ${(props.isTablet) ? 'tablet' : ''}`}>
          <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 9, desktop: 9 }}
          >
            <div className="Main-Title">
              <Title size="large" primitive="h2">
                5G Business Internet
              </Title>
            </div>
            <div></div>
          </Col>

          <Col colSizes={{ mobile: 4, tablet: 5, desktop: 5 }} colGutter={true}>
            <Body size="large" primitive="h2">
            Get fast speed, with unlimited data, to optimize your business network.
            </Body>
          </Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col colSizes={{ mobile: 2, tablet: 3, desktop: 3 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Prices start at:
            </Body>
            <Body size="large" primitive="h2">
              $69/mo*
            </Body>
          </Col>
          <Col colSizes={{ mobile: 2, tablet: 2, desktop: 2 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Speeds start at:
            </Body>
            <Body size="large" primitive="h2">
            100 Mbps (download)
            </Body>
          </Col>

          <Col
            colSizes={{ mobile:4, tablet: 5, desktop: 5 }}
            colGutter={true}
          ></Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col colSizes={{ mobile: 4, tablet: 6, desktop: 6 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Benefits:
            </Body>
            <Body size="large" primitive="h2">
            Fast speeds, 10-year price lock, low lag.
            </Body>
          </Col>

          <Col
            colSizes={{ mobile: 6, tablet: 5, desktop: 5 }}
            colGutter={true}
          ></Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col
            colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
            colGutter={true}
            className="topSpace"
          >
            <Body size="large" primitive="h2" bold={true}>
              5G Business Internet is best for:
            </Body>
            <Body size="large" primitive="h2">
            Businesses of any size, which require wide bandwidth and heavy data usage.
            </Body>
          </Col>
          { props.isMobileOnly ? (<Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              className="topSpace"
            >
              <Body size="small" primitive="h2">
                {" "}
                *Plus taxes & fees. Speeds vary. Price lock applies to monthly access fee only. Terms & restrictions apply. Click BUY for details.

              </Body>
            </Col>) : (<Col
              className="Title-section">
            </Col>)}
          <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
          >
            <div className="Main-Title">
              <Button
                secondary
                size="large"
                onClick={() => {props.redirectionHandler({"is5G":true});props.enableSpinner()}}
                className={`${props.bgForFirst ? "bgBtn" : "transperentButton"} ${props.isMobileOnly?'button-mobile':''}`}
              >
                Buy
              </Button>
            </div>
          </Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          { props.isMobileOnly ? (<Col
              className="Title-section">
            </Col>) : (<Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              className="topSpace"
            >
              <Body size="small" primitive="h2">
                {" "}
                *Plus taxes & fees. Speeds vary. Price lock applies to monthly access fee only. Terms & restrictions apply. Click BUY for details.

              </Body>
            </Col> )}
            <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            className="topSpace"
            > 
            </Col>
        </Row>
      ) : (
        <Fragment></Fragment>
      )}
    </Grid>
  );
}
